/**
 * @generated SignedSource<<c69eb95d161ce38cdf19609fc4190a3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersTypeMenuQuery$data = {
  readonly articleSearchV2: {
    readonly aggregations: {
      readonly articleTypeId: {
        readonly buckets: ReadonlyArray<{
          readonly doc_count: number;
          readonly key: string;
        }>;
      };
      readonly contentType: {
        readonly buckets: ReadonlyArray<{
          readonly doc_count: number;
          readonly key: string;
        }>;
      };
    };
  } | null | undefined;
  readonly " $fragmentType": "helpersTypeMenuQuery";
};
export type helpersTypeMenuQuery$key = {
  readonly " $data"?: helpersTypeMenuQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersTypeMenuQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersTypeMenuQuery"
};

(node as any).hash = "82c698ed478e2ff1f6ea2f37fdfbe0a4";

export default node;
